import { ICON__list_ol_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';

interface PROPS {
  field: FIELD__list_token;
}

export function G_BUTTON__prompt_link_tokens({ field }: PROPS) {
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   *
   */
  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let field_new = field.clone();
    field_new.tokens_are_independent_to_each_other = !field_new.tokens_are_independent_to_each_other;

    await UTILS__graph_data.update_field(generation_current.tool.graph, field_new);
  }
  /*
   *
   */

  function is_disabled(): boolean {
    return g_general__ui_disabled;
  }

  /*
   *
   */

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant="no-border-on-bar"
      size="rect-10-5"
      iconClassNameBase={`!text-component-item-foreground !size-3 ${field.tokens_are_independent_to_each_other ? '' : 'opacity-50'}`}
      iconClassNameHovered="!text-bar-foreground"
      renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
      Icon={ICON__list_ol_solid}
      disabled={is_disabled()}
      {...{ onClick }}
    ></UI_PRIMITIVE__button_with_icon_animated>
  );
}
